import React from 'react';

import {
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  borderColor,
  privateColor,
} from '../../library/constants';
import { getNodeFromNodeObjsWithPrId, urlGet/*, truncateWord*/ } from '../../library/calc';

import Multipartners from './multipartners';

class Siblings extends Multipartners {

  getSiblingsTR(){

    const getMockDom = (idx)=>{
      return (
        <tr key={`mock-${idx}`}>
          <td>
            <div style={{
              backgroundColor: borderColor,
              opacity: '.6',
              marginBottom: '2px',
            }}>&nbsp;
            </div>
          </td>
        </tr>
      )
    };

    let siblingsTr = [];
    let doThisManyTimes = this.defaultMockSiblingRows;
    while(doThisManyTimes > 0){
      doThisManyTimes -= 1;
      const idx = doThisManyTimes;
      siblingsTr.push(getMockDom(idx));
    }

    if(this.immediateFamilyIsFetched()) {

      const { nodeObjs, onClickEdit, reloadCanvasTree } = this.props;
      const immediateFam = this.props.nodeObj.immediateFam;

      let siblingsWithoutAddboxFocus = immediateFam.siblings.filter((sibling)=>{
        return sibling.prId !== nodeObjs[this.props.addNodeFormFocus].pr_id;
      });

      siblingsTr = siblingsWithoutAddboxFocus.map((sibling, idx)=>{

        let colorOfGender = sibling.g === 'm' ? maleDefaultColor: femaleDefaultColor;
        if(sibling.g === 'u'){
          colorOfGender = unGenderedDefaultColor;
        }

        if(typeof(sibling.nvp) !== 'undefined'){
          colorOfGender = privateColor;
        }

        let siblingFullname = sibling.nm;
        // siblingFullname = titleCase(siblingFullname);
        // const maxWidth = ( this.props.immediateFamVersion === 'addbox' ? 27: 35);
        // siblingFullname =  truncateWord({str:siblingFullname, length: maxWidth, useWordBoundary: false})

        if(urlGet('nodeIs') === "prId") siblingFullname = `${sibling.nm} - ${sibling.prId}`;
        if(urlGet('nodeIs') === "n") siblingFullname = `${sibling.nm} - ${sibling.n}`;


        return (
            <tr key={`trSibling${idx}`}>
              <td  className='family-list'>
                <div  className='flip-anchor-bullet' style={{
                  color: `${colorOfGender}`,
                  // textDecoration: 'none',
                }}>◉&nbsp;
                </div>
                <div className='flip-anchor-link' onClick={()=>{
                      this.onClick(sibling);
                    }}
                >
                  {siblingFullname}
                </div>
                <div>
                  <span
                    className={ `svgicon`}
                    style={this.getIconStyle().tree}
                    onClick={()=>{
                      //hidePedigreeAddbox();
                      if( this.props.chartType === 'fan') this.props.refocusFanChart({prId: sibling.prId})
                      else reloadCanvasTree(sibling.prId);
                    }}
                  >&nbsp;</span>
                  <span
                    className={ `svgicon ${( typeof(sibling.e) === 'undefined' ? 'hide': '')}`  }
                    style={this.getIconStyle().edit}
                    onClick={()=>{
                      const n = getNodeFromNodeObjsWithPrId({nodeObjs, prId: sibling.prId, fromWhere: 'addbox'});
                      onClickEdit(n, sibling.prId);
                    }}
                  >&nbsp;
                  </span>
                </div>
              </td>
            </tr>
        )
      });

    };

    return siblingsTr;
  }


}




export default Siblings;

